import React, { Component, useEffect, useState, useRef } from "react";
import { Tab, Col, Row, Card } from "react-bootstrap";
import InfoHeader from "../comman/infoHeader";
import Pagination from "../comman/pagination";
import { paginate, calculateIndex } from "../utlis/paginate";
import GenerateExcel from "./GenerateExcel";
import GeneratePdf from "./GeneratePdf";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PieChart from "../Charts/pie";
import BarChart from "../Charts/bar";
import { getAllYears, getMonthName } from "../services/appService";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getDataTypeApplicationReports, loadDataTypeApplicationReports } from "../app/store/reports";
import { getAllCandidateList, loadAllCandidateList } from "../app/store/candidate";
import { getApplicationReportPartnerStats, getPartnerListByType, loadApplicationReportPartnerStats, loadPartnerListByType } from "../app/store/partner";

const ApplicationReport = () => {
  const route = [{ name: "Analytics", url: "" }];

  const [reportData, setReportData] = useState([]);
  const [allReportData, setAllReportData] = useState([]);
  const [allCandidateList, setAllCandidateList] = useState([]);
  const [partnerCandidateList, setPartnerCandidateList] = useState([]);
  const [partnerListByType, setPartnerListByType] = useState([]);
  const [partnerType, setPartnerType] = useState("");
  const [selectedJsonData, setSelectedJsonData] = useState("");
  const [selectedPartnerId, setSelectedPartnerId] = useState("");
  const [subcontractorDdName] = useState("SubcontractorEnrollmentForm");
  const [recruiterDdName] = useState("RecruiterEnrollmentForm");
  const [candidateDdName] = useState("CandidateOnboardingForm");

  // New Search & Stats State
  const [searchTerm, setSearchTerm] = useState("");
  const [fieldSearchTerm, setFieldSearchTerm] = useState("");
  const [excelShowHide, setExcelShowHide] = useState(false);
  const [pdfShowHide, setPdfShowHide] = useState(false);
  const [selectedCol, setSelectedCol] = useState([]);
  const [selectedColData, setSelectedColData] = useState([]);
  const [subcontractorsCount, setSubcontractorsCount] = useState(0);
  const [recruitersCount, setRecruitersCount] = useState(0);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const reportRef = useRef();
  const categoryRequestIdRef = useRef(0);

  const dataTypeApplicationReportsSelector = useSelector(getDataTypeApplicationReports);
  const allCandidateListSelector = useSelector(getAllCandidateList);
  const partnerListByTypeSelector = useSelector(getPartnerListByType);
  const applicationReportPartnerStatsSelector = useSelector(getApplicationReportPartnerStats);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Entity Data"));
    dispatch(setCurrentRoute(route));
  }, []);

  useEffect(() => {
    dispatch(loadDataTypeApplicationReports());
    dispatch(loadAllCandidateList());
    dispatch(loadApplicationReportPartnerStats("Sub-Contractors"));
    dispatch(loadApplicationReportPartnerStats("Recruiter"));
  }, []);

  useEffect(() => {
    setSubcontractorsCount(applicationReportPartnerStatsSelector?.subcontractors?.length || 0);
    setRecruitersCount(applicationReportPartnerStatsSelector?.recruiters?.length || 0);
  }, [applicationReportPartnerStatsSelector]);

  useEffect(() => {
    if (dataTypeApplicationReportsSelector.length > 0) {
      setAllReportData(dataTypeApplicationReportsSelector);
    }
  }, [dataTypeApplicationReportsSelector]);

  useEffect(() => {
    setAllCandidateList(allCandidateListSelector);
  }, [allCandidateListSelector]);

  useEffect(() => {
    setPartnerListByType(partnerListByTypeSelector);
  }, [partnerListByTypeSelector]);

  const handleRefresh = () => {
    dispatch(loadDataTypeApplicationReports());
    dispatch(loadAllCandidateList());
    dispatch(loadApplicationReportPartnerStats("Sub-Contractors"));
    dispatch(loadApplicationReportPartnerStats("Recruiter"));
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      dispatch(loadPartnerListByType(partnerType, 0));
    }
  };

  const getAttribute = (t) => {
    if (t?.data && t?.data !== "") {
      const items = JSON.parse(t.data);
      return items;
    }
    return [];
  };

  const getAttributeValue = (d, t, att) => {
    if (d?.appData && d.appData === "") return "";
    try {
      const itemValues = JSON.parse(d.appData);
      const appShortName = Object.keys(itemValues)[1];
      const items = itemValues[appShortName][t.name.toLowerCase()];
      return items && items["@" + att];
    } catch (e) {
      return "";
    }
  };

  const handleCategorySelect = async (partType) => {
    const requestId = categoryRequestIdRef.current + 1;
    categoryRequestIdRef.current = requestId;
    setIsCategoryLoading(true);
    setPartnerType(partType);
    setSelectedPartnerId("");
    setSelectedJsonData("");
    setSearchTerm("");
    setFieldSearchTerm("");

    await new Promise((resolve) => window.requestAnimationFrame(resolve));

    try {
      let rptData = [];
      if (partType === "Sub-Contractors" || partType === "Recruiter") {
        const partners = await dispatch(loadPartnerListByType(partType, 0));
        if (categoryRequestIdRef.current !== requestId) return;

        setPartnerListByType(Array.isArray(partners) ? partners : []);
        if (partType === "Sub-Contractors")
          rptData = allReportData.filter((x) => x.name === subcontractorDdName);
        if (partType === "Recruiter")
          rptData = allReportData.filter((x) => x.name === recruiterDdName);
      } else {
        const filterCandidates = allCandidateList.filter((x) => x.registrationType === partType);
        setPartnerCandidateList(filterCandidates);
        rptData = allReportData.filter((x) => x.name === candidateDdName);
      }

      if (categoryRequestIdRef.current === requestId) {
        setReportData(rptData);
      }
    } finally {
      if (categoryRequestIdRef.current === requestId) {
        setIsCategoryLoading(false);
      }
    }
  };

  const handleSelectEntity = (id) => {
    let jsonData = "";
    const numId = parseInt(id);
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      const partner = partnerListByType.filter((x) => x.fuid === numId);
      if (partner.length > 0 && partner[0].contact1) {
        jsonData = partner[0].contact1.performerData;
      }
    } else {
      const perf = allCandidateList.filter((x) => x.performerid === numId);
      if (perf.length > 0) {
        jsonData = perf[0].performerData;
      }
    }
    setSelectedJsonData(jsonData);
    setSelectedPartnerId(numId);
    setFieldSearchTerm("");
  };

  // Compute reactive dashboard stats
  const w2Count = allCandidateList.filter(x => x.registrationType === "W2 Basis").length;
  const c2cCount = allCandidateList.filter(x => x.registrationType === "C2C Basis").length;
  const i1099Count = allCandidateList.filter(x => x.registrationType === "1099 Basis").length;
  const totalEntities = allCandidateList.length + subcontractorsCount + recruitersCount;

  // Selected profile details
  let selectedEntityName = "";
  if (selectedPartnerId) {
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      const entity = partnerListByType.find((x) => x.fuid === selectedPartnerId);
      if (entity) selectedEntityName = entity.label;
    } else {
      const candidate = allCandidateList.find((x) => x.performerid === selectedPartnerId);
      if (candidate) selectedEntityName = `${candidate.performername || ""} ${candidate.lastName || ""}`.trim();
    }
  }

  // Filter lists based on search
  const getFilteredList = () => {
    if (partnerType === "Sub-Contractors" || partnerType === "Recruiter") {
      return partnerListByType.filter(item =>
        item.label && item.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else {
      return partnerCandidateList.filter(item => {
        const fullName = `${item.performername || ""} ${item.lastName || ""}`.trim();
        return fullName.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }
  };

  // Charts configurations
  const candidateChartData = {
    label: ["W2 Hourly", "C2C Basis", "1099 Basis"],
    data: [w2Count, c2cCount, i1099Count]
  };

  const entityBarData = [
    {
      type: "Entity Count",
      label: ["Candidates", "Subcontractors", "Recruiters"],
      data: [allCandidateList.length, subcontractorsCount, recruitersCount]
    }
  ];

  const filteredEntities = getFilteredList();

  const handleexcelShowHide = () => {
    setExcelShowHide(false);
    setSelectedCol([]);
    setSelectedColData([]);
  };

  const handleExcelExport = () => {
    const headers = [["Field Metric", "Registered Value"]];
    const data = [];
    if (selectedJsonData) {
      reportData.forEach((t) => {
        getAttribute(t).forEach((m) => {
          data.push([
            m.Label,
            String(getAttributeValue({ appData: selectedJsonData }, t, m.Name) || "")
          ]);
        });
      });
    }
    setSelectedCol(headers);
    setSelectedColData(data);
    setExcelShowHide(true);
  };

  const handlepdfShowHide = () => {
    setPdfShowHide(false);
    setSelectedCol([]);
    setSelectedColData([]);
  };

  const handleExportPDF = () => {
    const headers = [["Field Metric", "Registered Value"]];
    const data = [];
    if (selectedJsonData) {
      reportData.forEach((t) => {
        getAttribute(t).forEach((m) => {
          data.push([
            m.Label,
            String(getAttributeValue({ appData: selectedJsonData }, t, m.Name) || "")
          ]);
        });
      });
    }
    setSelectedCol(headers);
    setSelectedColData(data);
    setPdfShowHide(true);
  };

  // Render GeneratePdf and GenerateExcel tags
  const renderExporters = () => (
    <>
      <GeneratePdf
        handlepdfShowHide={handlepdfShowHide}
        pdfShowHide={pdfShowHide}
        selectedCol={selectedCol}
        selectedColData={selectedColData}
      />
      <GenerateExcel
        handleexcelShowHide={handleexcelShowHide}
        excelShowHide={excelShowHide}
        selectedCol={selectedCol}
        selectedColData={selectedColData}
      />
    </>
  );

  return (
    <React.Fragment>
      <style>{`
        /* Black & White Theme Styling for ApplicationReport (matching WorkflowUser & CustomReport) */
        .ar-hub {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          background: #f8fafc;
          min-height: calc(100vh - 120px);
          padding: 8px 0;
        }

        /* WorkflowUser Card Layout & Header Bar */
        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 24px !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 16px 22px !important;
          background: transparent !important;
          border-bottom: 1px solid #f1f5f9 !important;
          border-radius: 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: 32px !important;
          height: auto !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }

        .ar-card {
          background: #ffffff;
          border: 1px solid rgba(226, 232, 240, 0.8);
          border-radius: 0 !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .ar-card:hover {
          box-shadow: 0 12px 24px -4px rgba(15, 23, 42, 0.08), 0 4px 6px -2px rgba(15, 23, 42, 0.04);
        }



        .ar-section-label {
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #64748b;
          margin-bottom: 10px;
          padding-left: 2px;
        }

        /* Category tabs (WorkflowUser style) */
        .ar-cat-menu {
          display: flex;
          flex-direction: column;
          gap: 4px;
          margin-bottom: 20px;
        }

        .ar-cat-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 11px 14px;
          border-radius: 0;
          cursor: pointer;
          background: #ffffff;
          border: 1px solid transparent;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          font-weight: 500;
          font-size: 14px;
          color: #1e293b;
          position: relative;
        }

        .ar-cat-item:hover {
          background: #f5f5f5;
          color: #171717;
          border-color: #e5e5e5;
          transform: translateX(3px);
        }

        .ar-cat-item.active {
          background: #f5f5f5;
          border-color: #d4d4d4;
          color: #171717;
          box-shadow: inset 4px 0 0 0 #171717;
        }

        .ar-cat-item.active .ar-cat-icon-wrap {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #d4d4d4 !important;
          box-shadow: none;
        }

        .ar-cat-icon-wrap {
          width: 34px;
          height: 34px;
          border-radius: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          flex-shrink: 0;
          transition: all 0.2s ease;
          background: rgba(23, 23, 23, 0.06);
          color: #171717;
          border: 1px solid rgba(23, 23, 23, 0.12);
        }

        .ar-cat-label {
          flex: 1;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ar-cat-count {
          font-size: 12px;
          font-weight: 500;
          padding: 2px 7px;
          border-radius: 0;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          flex-shrink: 0;
          min-width: 24px;
          text-align: center;
          transition: all 0.2s ease;
        }

        .ar-cat-item.active .ar-cat-count {
          background: #171717;
          color: #ffffff;
          border-color: #171717;
        }

        .ar-cat-divider {
          height: 1px;
          background: #e2e8f0;
          margin: 8px 0 14px;
        }

        /* Search input styling */
        .ar-search-wrapper {
          position: relative;
          margin-bottom: 14px;
        }

        .ar-search-input {
          width: 100%;
          padding: 9px 16px 9px 38px;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 400;
          color: #1e293b;
          transition: all 0.2s ease;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }

        .ar-search-input:focus {
          outline: none;
          border-color: #171717;
          box-shadow: 0 0 0 4px rgba(23, 23, 23, 0.1);
          background: #fafafa;
        }

        .ar-search-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
        }

        /* Entity list scrollable container */
        .ar-entity-list {
          max-height: 480px;
          overflow-y: auto;
          padding-right: 2px;
        }

        .ar-category-loading {
          min-height: 150px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          color: #64748b;
          font-size: 13px;
          font-weight: 500;
        }

        .ar-category-loading .spinner-border {
          width: 28px;
          height: 28px;
          border-width: 3px;
          color: #2563eb;
        }

        .ar-entity-list::-webkit-scrollbar {
          width: 5px;
        }

        .ar-entity-list::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 0;
        }

        .ar-entity-item {
          display: flex;
          align-items: center;
          padding: 10px 12px;
          border-radius: 0;
          cursor: pointer;
          margin-bottom: 6px;
          border: 1px solid transparent;
          transition: all 0.15s ease;
          background: #ffffff;
        }

        .ar-entity-item:hover {
          background: #f8fafc;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
        }

        .ar-entity-item.active {
          background: #f5f5f5;
          border-color: #d4d4d4;
          box-shadow: inset 3px 0 0 0 #171717;
        }

        .ar-entity-name {
          font-weight: 500;
          font-size: 14px;
          color: #1e293b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ar-entity-sub {
          font-size: 12px;
          font-weight: 400;
          color: #64748b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* Hero Header */
        .ar-hero-header {
          background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
          border: 1px solid rgba(15, 23, 42, 0.08);
          border-radius: 0;
          color: #171717;
          margin-bottom: 24px;
          padding: 30px 32px 26px;
          position: relative;
          overflow: hidden;
          box-shadow:
            0 1px 3px rgba(15, 23, 42, 0.02),
            0 8px 24px rgba(15, 23, 42, 0.04),
            inset 0 1px 0 #ffffff;
        }

        .ar-hero-kicker {
          color: #64748b;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .ar-hero-title-main {
          font-size: 18px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: -0.02em;
          margin-bottom: 10px;
          line-height: 1.2;
        }

        .ar-hero-copy {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 0;
          max-width: 720px;
        }

        .ar-hero-watermark {
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 72px;
          color: #171717;
          opacity: 0.04;
          pointer-events: none;
        }

        /* Dashboard Metrics */
        .ar-kpi-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
          gap: 16px;
          margin-bottom: 24px;
        }

        .ar-kpi-card {
          padding: 16px 20px;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 0;
        }

        .ar-kpi-icon-wrapper {
          width: 44px;
          height: 44px;
          border-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          margin-right: 14px;
          flex-shrink: 0;
          background: rgba(23, 23, 23, 0.06) !important;
          color: #171717 !important;
          border: 1px solid rgba(23, 23, 23, 0.1) !important;
        }

        .ar-kpi-num {
          font-size: 24px;
          font-weight: 500;
          color: #1e293b;
          line-height: 1.1;
          margin-bottom: 2px;
        }

        .ar-kpi-label {
          font-size: 12px;
          color: #64748b;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        /* Detailed Report View styling */
        .ar-detail-view {
          overflow: hidden;
        }

        .ar-hero {
          background: transparent;
          padding: 24px 28px;
          color: #171717;
          position: relative;
          overflow: hidden;
          border-bottom: 1px solid #e2e8f0;
        }

        .ar-hero-glow {
          display: none;
        }

        .ar-hero-body {
          display: flex;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .ar-hero-name {
          font-size: 18px;
          font-weight: 500;
          color: #1e293b;
          margin-bottom: 2px;
          letter-spacing: -0.01em;
        }

        .ar-hero-badge {
          display: inline-block;
          padding: 4px 10px;
          background: #f5f5f5;
          border-radius: 0;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: #1e293b;
          border: 1px solid #d4d4d4;
        }

        .ar-actions-bar {
          background: #fdfdfd;
          border-bottom: 1px solid #e2e8f0;
          padding: 12px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
        }

        .ar-actions-btns {
          display: flex;
          align-items: center;
        }

        .ar-actions-btns > * {
          margin-right: 8px !important;
        }

        .ar-actions-btns > *:last-child {
          margin-right: 0 !important;
        }

        .ar-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 7px 14px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          border-radius: 0;
          border: 1px solid #cbd5e1;
          background: #ffffff;
          color: #1e293b;
          transition: all 0.15s ease;
          cursor: pointer;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
        }

        .ar-btn:hover:not(:disabled) {
          background: #f8fafc;
          color: #0f172a;
          border-color: #94a3b8;
        }

        .ar-btn-primary {
          background: #ffffff;
          color: #171717;
          border-color: #cbd5e1;
        }

        .ar-btn-primary:hover:not(:disabled) {
          background: #f8fafc;
          color: #0f172a;
          border-color: #94a3b8;
        }

        .ar-report-grid {
          padding: 24px;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 14px;
          background: #ffffff;
        }

        .ar-field-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 0;
          padding: 12px 14px;
          display: flex;
          flex-direction: column;
          transition: all 0.15s ease;
        }

        .ar-field-card:hover {
          border-color: #171717;
          background: #ffffff;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.04);
        }

        .ar-field-label {
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          color: #64748b;
          margin-bottom: 4px;
          letter-spacing: 0.08em;
        }

        .ar-field-value {
          font-size: 14px;
          font-weight: 400;
          color: #1e293b;
          word-break: break-all;
        }

        /* Print stylesheet */
        @media print {
          body * {
            visibility: hidden;
          }
          .ar-detail-view, .ar-detail-view * {
            visibility: visible;
          }
          .ar-detail-view {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
          }
          .ar-actions-bar {
            display: none !important;
          }
        }
      `}</style>

      <div className="ar-hub">
        <div className="card mb-4 shadow-none wf-main-card">
          {/* Card Header Bar matching WorkflowUser & CustomReport */}
          <div className="wf-card-header-bar">
            <div className="wf-header-left">
              <div>
                <h2 style={{ fontSize: "18px", fontWeight: 500, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#1e293b", margin: 0, lineHeight: 1.2 }}>
                  Entity Data Hub
                </h2>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 400, marginTop: "2px" }}>
                  Browse &amp; inspect entity records, review aggregate workforce metrics, and export data.
                  {allCandidateList.length === 0 && (
                    <span className="spinner-border spinner-border-sm text-dark ml-2" style={{ width: "12px", height: "12px", borderWidth: "2px" }} role="status"></span>
                  )}
                </div>
              </div>
            </div>
            <div>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                title="Refresh directory"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          {/* Card Body Content */}
          <div className="card-body px-3 pt-3 pb-3 wf-tabs-container">
            <Row>
              {/* Left Panel: Category & Entity Selector */}
              <Col lg={4} className="mb-4">
                <Card className="ar-card rounded-0 p-3 h-100">
                  {/* Section Label */}
                  <div className="ar-section-label">Select Category</div>

                  {/* Vertical Category Selector Tabs */}
                  <div className="ar-cat-menu">
                <div
                  className={`ar-cat-item ${partnerType === "W2 Basis" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("W2 Basis")}
                >
                  <div className="ar-cat-icon-wrap">
                    <i className="fa fa-user" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">W2 Hourly Candidates</span>
                  <span className="ar-cat-count">{w2Count}</span>
                </div>
                <div
                  className={`ar-cat-item ${partnerType === "C2C Basis" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("C2C Basis")}
                >
                  <div className="ar-cat-icon-wrap">
                    <i className="fa fa-building-o" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">C2C Candidates</span>
                  <span className="ar-cat-count">{c2cCount}</span>
                </div>
                <div
                  className={`ar-cat-item ${partnerType === "1099 Basis" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("1099 Basis")}
                >
                  <div className="ar-cat-icon-wrap">
                    <i className="fa fa-user-circle-o" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">1099 Candidates</span>
                  <span className="ar-cat-count">{i1099Count}</span>
                </div>

                <div className="ar-cat-divider" />

                <div
                  className={`ar-cat-item ${partnerType === "Sub-Contractors" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("Sub-Contractors")}
                >
                  <div className="ar-cat-icon-wrap">
                    <i className="fa fa-handshake-o" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">Subcontractors</span>
                  <span className="ar-cat-count">{subcontractorsCount}</span>
                </div>
                <div
                  className={`ar-cat-item ${partnerType === "Recruiter" ? "active" : ""}`}
                  onClick={() => handleCategorySelect("Recruiter")}
                >
                  <div className="ar-cat-icon-wrap">
                    <i className="fa fa-briefcase" aria-hidden="true" />
                  </div>
                  <span className="ar-cat-label">Recruiters</span>
                  <span className="ar-cat-count">{recruitersCount}</span>
                </div>
              </div>

              {/* List of Entities belonging to selected category */}
              {partnerType !== "" && (
                <React.Fragment>
                  <div className="ar-search-wrapper">
                    <i className="fa fa-search ar-search-icon"></i>
                    <input
                      type="text"
                      placeholder={`Search ${partnerType === "Sub-Contractors"
                        ? "Subcontractors"
                        : partnerType === "Recruiter"
                          ? "Recruiters"
                          : "Candidates"
                        }...`}
                      className="ar-search-input"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      disabled={isCategoryLoading}
                    />
                  </div>

                  <div className="ar-entity-list" aria-busy={isCategoryLoading}>
                    {isCategoryLoading ? (
                      <div className="ar-category-loading" role="status">
                        <span className="spinner-border" aria-hidden="true"></span>
                        <span>Loading {partnerType === "Sub-Contractors" ? "subcontractors" : partnerType === "Recruiter" ? "recruiters" : "candidates"}...</span>
                      </div>
                    ) : filteredEntities.length > 0 ? (
                      filteredEntities.map((item) => {
                        const id =
                          partnerType === "Sub-Contractors" || partnerType === "Recruiter"
                            ? item.fuid
                            : item.performerid;
                        const name =
                          partnerType === "Sub-Contractors" || partnerType === "Recruiter"
                            ? item.label
                            : `${item.performername || ""} ${item?.lastName || ""}`.trim();
                        const email =
                          partnerType === "Sub-Contractors" || partnerType === "Recruiter"
                            ? item.contact1?.performeremail || item.contact1?.email || "No email provided"
                            : item.email || item.performeremail || "No email provided";

                        return (
                          <div
                            key={id}
                            className={`ar-entity-item ${selectedPartnerId === id ? "active" : ""}`}
                            onClick={() => handleSelectEntity(id)}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div className="ar-entity-name">{name}</div>
                              <div className="ar-entity-sub">{email}</div>
                            </div>
                            <div>
                              <i className="fa fa-angle-right" style={{ color: "#cbd5e1" }}></i>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-center py-4 text-muted">
                        <i className="fa fa-folder-open-o fa-2x mb-2 d-block"></i>
                        <small>No records matched your search</small>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </Card>
          </Col>

          {/* Right Panel: Analytics Dashboard OR Report detailed view */}
          <Col lg={8} className="mb-4">
            {!selectedPartnerId ? (
              /* LANDING DASHBOARD */
              <div className="animate-fade-in">
                <div className="ar-hero-header">
                  <div className="ar-hero-kicker">ENTITY DATA ANALYTICS</div>
                  <h1 className="ar-hero-title-main">Entity Hub Analytics</h1>
                  <p className="ar-hero-copy">
                    Welcome to the Entity Analytics &amp; Form Hub. Select an entity category to inspect records, or review aggregate workforce metrics below.
                  </p>
                  <i className="fa fa-database ar-hero-watermark" aria-hidden="true"></i>
                </div>

                {/* KPI Metrics */}
                <div className="ar-kpi-grid">
                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper">
                      <i className="fa fa-users"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{totalEntities}</div>
                      <div className="ar-kpi-label">Total Entities</div>
                    </div>
                  </div>

                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper">
                      <i className="fa fa-graduation-cap"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{allCandidateList.length}</div>
                      <div className="ar-kpi-label">Candidates</div>
                    </div>
                  </div>

                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper">
                      <i className="fa fa-handshake-o"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{subcontractorsCount}</div>
                      <div className="ar-kpi-label">Subcontractors</div>
                    </div>
                  </div>

                  <div className="ar-kpi-card ar-card">
                    <div className="ar-kpi-icon-wrapper">
                      <i className="fa fa-briefcase"></i>
                    </div>
                    <div>
                      <div className="ar-kpi-num">{recruitersCount}</div>
                      <div className="ar-kpi-label">Recruiters</div>
                    </div>
                  </div>
                </div>

                {/* Charts Section */}
                <Row>
                  <Col md={6} className="mb-4">
                    <Card className="ar-card rounded-0 p-3 h-100">
                      <h3 style={{ fontSize: "12px", fontWeight: 600, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#64748b", letterSpacing: "0.08em" }} className="mb-3 text-muted uppercase">
                        Candidates Breakdown
                      </h3>
                      {allCandidateList.length > 0 ? (
                        <PieChart graphData={candidateChartData} />
                      ) : (
                        <div className="text-center py-5 text-muted"><small>Loading chart data...</small></div>
                      )}
                    </Card>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Card className="ar-card rounded-0 p-3 h-100">
                      <h3 style={{ fontSize: "12px", fontWeight: 600, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#64748b", letterSpacing: "0.08em" }} className="mb-3 text-muted uppercase">
                        Entity Distribution
                      </h3>
                      {allCandidateList.length > 0 ? (
                        <BarChart graphData={entityBarData} />
                      ) : (
                        <div className="text-center py-5 text-muted"><small>Loading chart data...</small></div>
                      )}
                    </Card>
                  </Col>
                </Row>
              </div>
            ) : (
              /* DETAILED PROFILE REPORT VIEW */
              <div className="ar-detail-view ar-card animate-fade-in">
                {/* Hero Gradient Block */}
                <div className="ar-hero">
                  <div className="ar-hero-glow"></div>
                  <div className="ar-hero-body">
                    <div>
                      <h2 className="ar-hero-name mb-1">{selectedEntityName}</h2>
                      <span className="ar-hero-badge">
                        {partnerType === "Sub-Contractors" ? "Subcontractor" : partnerType === "Recruiter" ? "Recruiter" : partnerType}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Actions & Filters */}
                <div className="ar-actions-bar">
                  <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                    <button
                      type="button"
                      className="ar-btn"
                      onClick={() => {
                        setSelectedPartnerId("");
                        setSelectedJsonData("");
                      }}
                      title="Back to Analytics"
                    >
                      <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
                    </button>
                    <div style={{ position: "relative", width: "220px" }}>
                      <i className="fa fa-search ar-search-icon" style={{ left: "12px" }}></i>
                      <input
                        type="text"
                        placeholder="Search report fields..."
                        className="form-control form-control-sm"
                        style={{ paddingLeft: "32px", fontSize: "14px", fontWeight: 400, height: "auto", minHeight: "32px", borderRadius: "0", fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#1e293b" }}
                        value={fieldSearchTerm}
                        onChange={(e) => setFieldSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="ar-actions-btns">
                    {/* Excel Export component */}
                    <button
                      type="button"
                      className="ar-btn"
                      disabled={!selectedJsonData}
                      onClick={handleExcelExport}
                    >
                      <i className="fa fa-file-excel-o" style={{ color: "#171717", marginRight: "6px" }} aria-hidden="true"></i>
                      Excel Export
                    </button>

                    {/* PDF Export Component */}
                    <button
                      type="button"
                      className="ar-btn ar-btn-primary"
                      disabled={!selectedJsonData}
                      onClick={handleExportPDF}
                    >
                      <i className="fa fa-file-pdf-o" style={{ marginRight: "6px" }} aria-hidden="true"></i>
                      Export PDF
                    </button>
                  </div>
                </div>

                {/* Detailed Responsive Cards Grid */}
                <div ref={reportRef} className="ar-report-grid">
                  {selectedJsonData ? (
                    reportData.map((t) => {
                      const attributes = getAttribute(t);
                      const filteredAttributes = attributes.filter(
                        (m) =>
                          m.Label.toLowerCase().includes(fieldSearchTerm.toLowerCase()) ||
                          String(getAttributeValue({ appData: selectedJsonData }, t, m.Name) || "")
                            .toLowerCase()
                            .includes(fieldSearchTerm.toLowerCase())
                      );

                      if (filteredAttributes.length === 0) {
                        return (
                          <div className="col-12 text-center py-5 text-muted" key={t.name}>
                            <i className="fa fa-search-plus fa-2x mb-2 d-block"></i>
                            <small>No matching report fields found</small>
                          </div>
                        );
                      }

                      return filteredAttributes.map((m) => {
                        const val = getAttributeValue({ appData: selectedJsonData }, t, m.Name);
                        return (
                          <div className="ar-field-card" key={m.Name}>
                            <span className="ar-field-label">{m.Label}</span>
                            <span className="ar-field-value">
                              {val || <em className="text-muted" style={{ fontWeight: 400 }}>Not Provided</em>}
                            </span>
                          </div>
                        );
                      });
                    })
                  ) : (
                    <div className="col-12 text-center py-5">
                      <span className="spinner-border text-dark d-block mx-auto mb-3" role="status"></span>
                      <small className="text-muted">Loading entity profile details...</small>
                    </div>
                  )}
                </div>
              </div>
            )}
          </Col>
        </Row>
          </div>
        </div>
      </div>
      {renderExporters()}
    </React.Fragment>
  );
};

export default ApplicationReport;
